import React, { FC, useEffect, useState, useMemo } from "react";
import { Button, Table, Upload, Tooltip, message, notification } from "antd";
import { YhBox } from "@/components/YhBox";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import { usePurchasePlanDetailsModel } from "./purchasePlanDetailsModel";
import { RouterParamType } from "@/model/navModel";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { IDetailList } from "../../purchasePlanType"
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { ISelectOption } from "@/components/YhFormBox/Types";
import { IVRMshelfDetail, IVRMshelfSearch } from "@/views/base/warehouse/warehouseTypes";
import { warehouseService } from "@/views/base/warehouse/warehouseService";
import { formatNum, formatIntPoint, bigNumber, momentFormat } from "@/utils/utils";
import { DetailType } from "@/types/ScmEnums";
import { importPropsConfig } from "@/utils/importFile";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhBut } from "@/components/YhButton";
import { purchasePoService } from "@/views/purchase/po/purchasePoService";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import { useDictModel } from "@/views/base/dict/dictModel";
import { LookPictureModal } from "@/views/lookPicture";
import { PictureOutlined } from "@ant-design/icons";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        detailAddList,
        detailDataSource,
        detailLookList,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        detailAddForm,
        detailLookForm,
        detailEditForm,
        setDetaiAddDataRow,
        setDetaiAddDataRowKeys,
        setDetailDataRowKeys,
        setDetailDataRow,
        setAddModalVisible,
        setDetailAddList,
        setDetailDataSource,
        detailDetailList,
        downloadTpl,
        modelScreenMethod,
        setHistoryVisible,
        setHistoryRow,
        setTopButsControl,
        topButsControl,
        arrivalExport,
        supMore, setSupMore,
        more, setMore,
        warehouseData, setWarehouseData,
    } = usePurchasePlanDetailsModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const onHistoryModel = (record: IDetailList) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    const { getTreeNodeName } = useDictModel();
    const { shopAndOrg: { shopId, shopName }, setLoadingInfo } = useGlobalModel()
    const detailForm = mode === "add" ? detailAddForm : mode === "edit" ? detailEditForm : detailLookForm;
    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<IVRMshelfDetail[]>([]);
    const [loading, setLoading] = useState<boolean>(false)

    const importCallback = async (list: any) => {
        setLoadingInfo({ loadingVisible: false })
        if (list && list.length) {
            let tempArr: any[] = [];
            let str = ""
            list.forEach((item: { status: any; entity: any; msg: any; }) => {
                if (item.status) {
                    tempArr.push(item.entity ?? [])
                } else {
                    str += `【${item.msg}】`;
                }
            })
            str ? notification.warning({ message: '提醒', description: str, duration: 9 }) : message.success("导入成功")
            const { repetition, newDetailData } = await modelScreenMethod(tempArr, mode === 'add' ? detailAddList : detailDataSource, mode, 'import')
            if (mode === "add") {
                setDetailAddList(newDetailData.map((item: any) => { return { ...item, detailsId: new Date().getTime() + Math.floor(Math.random() * 10000) } }))
            } else if (mode === "edit") {
                setDetailDataSource(newDetailData.map((item: any) => { return { ...item, detailsId: new Date().getTime() + Math.floor(Math.random() * 10000) } }))
            }
            repetition.length != 0 && globalPrompt("message", { text: `${repetition.join(",")}，以上重复配件已过滤。`, type: "warning" });
        }
    }
    const importArrivalImportback = async (list: any) => {
        setLoadingInfo({ loadingVisible: false })
        if (list && list.length) {
            let tempArr: any[] = [];
            let str = ""
            detailDataSource.map((item) => {
                let newData = list.find((list: any) => list.id === item.id)
                if (newData && newData.status == true) {
                    tempArr.push({ ...item, num: newData.num, detailsId: newData.id })
                } else {
                    str += `【${newData.materialCode}:${newData.msg}】`;
                    tempArr.push({ ...item, detailsId: newData.id })
                }
            })
            str ? notification.warning({ message: '提醒', description: str, duration: 9 }) : message.success("导入成功")
            setDetailDataSource(tempArr)
        }
    }
    // 删除(做限制)
    const onRemove = (mode: string) => {
        detailDetailList(mode)
    }
    const action = <>
        {mode !== "look" && <>
            <YhAuth resCode={ResourceAuthEnum.P_PL_ED_ADD_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={detailForm.purchaseTypeCode ? false : true}
                    onClick={() => {
                        let { purchaseTypeCode } = detailForm;
                        if (!purchaseTypeCode) {
                            message.warning("请补全采购类型");
                            return false
                        }
                        setAddModalVisible(true)
                    }}
                >新增配件</Button>
            </YhAuth>
            {mode == 'add' && <YhAuth resCode={ResourceAuthEnum.P_PL_ED_DEL_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => { onRemove(mode) }}
                >批量删除</Button>
            </YhAuth>}
            {mode == 'edit' && <YhAuth resCode={ResourceAuthEnum.P_PL_ED_CANCEL_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => { onRemove(mode) }}
                >批量作废</Button>
            </YhAuth>}
            <YhAuth resCode={ResourceAuthEnum.P_PL_ED_IM}>
                <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/purchase/details/import`, importCallback, () => setLoadingInfo({ loadingVisible: true, txt: "快速导入中..." }), { shopId: detailForm.shopId, shopName: detailForm.shopName, direct: detailForm.purchaseTypeCode }, false)}>
                    <Button disabled={detailForm.purchaseTypeCode ? false : true} className="mr-5" type="primary" shape="round">导入</Button>
                </Upload>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_PL_ED_DLOAD}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={downloadTpl}
                >下载模板</Button>
            </YhAuth>
            {mode == 'edit' &&
                <>
                    <YhAuth resCode={ResourceAuthEnum.P_PL_ED_ARRIVALEXPORT}>
                        <Button
                            className="mr-5"
                            type="primary"
                            danger
                            disabled={topButsControl}
                            shape="round"
                            onClick={arrivalExport}
                        >登记导出</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_PL_ED_IMPORTARRIVALIMPORTBACK}>
                        <Upload disabled={topButsControl} showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/purchase/plan/arrivalImport`, importArrivalImportback, () => setLoadingInfo({ loadingVisible: true, txt: "快速导入中..." }), { shopId, shopName }, false)}>
                            <Button disabled={topButsControl} className="mr-5" type="primary" danger shape="round">登记导入</Button>
                        </Upload>
                    </YhAuth>
                </>}
        </>}
    </>;
    // //货位根据仓库code查询
    // const queryShelf = async (wsCode: string) => {
    //     let params = {
    //         pageSize: 10000,
    //         pageNum: 1,
    //         warehouseCode: wsCode,
    //     }
    //     const { retData } = await warehouseService.shelfAllPage(params)
    //     const newRecords = retData.map((item: IVRMshelfDetail) => { return { ...item, name: item.code } })
    //     setShelfAllList(newRecords)
    // }
    // const wsChanges = async (value: string, option: ISelectOption, record: IDetailList) => {
    //     if (option && option.value) {
    //         queryShelf(option.value as string)
    //     }
    // }
    //货位触焦
    // const shelfFocus = (record: any) => {
    //     if (record["warehouseCode"]) {
    //         queryShelf(record["warehouseCode"] as string)
    //     } else {
    //         setShelfAllList([]);
    //     }
    // }

    const shelfChange = (value: string, option: ISelectOption, record: IDetailList, rowIndex: number) => {
        let newData = mode === "edit" ? detailDataSource : detailAddList;
        newData.splice(rowIndex, 1, record);
        mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
        setTopButsControl(true)
    }
    //货位触焦 
    const shelfFocus = async (record: IDetailList, rowIndex: number) => {
        setLoading(true)
        try {
            let newData = mode === "edit" ? detailDataSource : detailAddList;
            const newRow = newData[rowIndex];
            let warehouseCode = record["warehouseCode"]
            if (warehouseCode) {
                //货位列表  判断是当前仓库的货位列表  不做接口请求
                let newRecords = shelfAllList.find(item => item.warehouseCode === warehouseCode) ? shelfAllList : [];
                if (!newRecords.length) {
                    const { retData } = await warehouseService.shelfAllPage({
                        pageSize: 10000,
                        pageNum: 1,
                        warehouseCode,
                    } as IVRMshelfSearch)
                    newRecords = retData.map((item: IVRMshelfDetail) => { return { ...item, name: item.code } })
                    setShelfAllList(newRecords)
                }
                //查询配件有没有在改仓库下采购过，
                let { retData } = await purchasePoService.getMaterialShelf({
                    shopId,
                    materialCode: record.materialCode,
                    warehouseCode: warehouseCode
                })
                // 采购过的货位带出来不可以编辑， 其它的可以编辑(有临时货位默认带出临时货位)
                if (retData.shelfCode) {
                    newRow.shelfCode = retData.shelfCode ?? '';
                    newRow.shelfId = retData.shelfId ?? '';
                    newRow.isPurShelf = retData.shelfCode ?? '';  //做是否可编辑
                    message.warning(`自动匹配到配件【${record.materialCode}】在该仓库下采购的货位，货位不可做修改操作！！`)
                    newData.splice(rowIndex, 1, { ...record, ...newRow });
                    mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
                    setTopButsControl(true)
                }
            } else {
                setShelfAllList([]);
            }
            setLoading(false)
        } catch (e) {
            setLoading(false)
        }
    }
    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [currentMaterialCode, setCurrentMaterialCode] = useState("");
    const handleOpenImageModal = (materialCode: string) => {
        setCurrentMaterialCode(materialCode);
        setImageModalVisible(true);
    };
    const handleCloseImageModal = () => {
        setImageModalVisible(false);
        setCurrentMaterialCode("");
    };
    const defaultColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '配件编号',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any, record: any) => (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <YhTootip text={text} onClick={() => onHistoryModel(record)} style={{ maxWidth: "130px" }} />
                    <PictureOutlined
                        style={{ color: '#009688', cursor: 'pointer', marginLeft: 4, fontSize: '22px' }}
                        onClick={() => handleOpenImageModal(record.materialCode)} // 点击打开图片模态框
                    />
                </div>
            ),
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,

        }, {
            title: '采购数量',
            width: 100,
            dataIndex: 'planNum',
            editable: mode === "add" ? true : detailEditForm.status !== "purchase-plan.transfer" && mode !== "look" && !detailForm.orderCode,
        },
        ...(() => {
            if (!roles.includes('hd-supplier')) {
                return [
                    {
                        title: '采购单价',
                        width: 100,
                        dataIndex: 'price',
                        editable: (mode !== "look" && !detailForm.orderCode) ? true : false,
                    }, {
                        title: '采购金额',
                        width: 100,
                        dataIndex: 'amount',
                        // editable: mode != "look" ? true : false,
                    }, {
                        title: '所属仓库',
                        width: 160,
                        dataIndex: 'warehouseCode',
                        editable: mode !== "look" && detailForm.purchaseTypeCode !== 'purchase-type.c' ? true : false,
                        editType: "select",
                        // onSelectChange: wsChanges,
                        options: transOptions(warehouseData[mode].map((item: any) => {
                            return { ...item, enable: item.name == '直发库' ? 0 : 1 }
                        }
                        )),
                        rules: [{ required: true, message: "请选择仓库" }],
                        render: (text: any) => transOptions(warehouseData[mode]).find(item => item.value === text)?.label ?? "请选择仓库",
                    }, {
                        title: '所属货位',
                        width: 150,
                        dataIndex: 'shelfCode',
                        editable: mode !== "look" && detailForm.purchaseTypeCode !== 'purchase-type.c' ? true : false,
                        editType: "select",
                        onSelectFocus: shelfFocus,
                        onSelectChange: shelfChange,
                        rules: [{ required: true, message: "请选择货位" }],
                        options: transOptions(shelfAllList),
                        render: (text: any) => text ?? "请选择货位",

                    }, {
                        title: '最小起订量',
                        width: 100,
                        dataIndex: 'minNum',
                    }, {
                        title: '到货时间',
                        width: 150,
                        dataIndex: 'transferTime',
                        render: (text: any) => text ? momentFormat(text) : ''

                    }, {
                        title: '到货数量',
                        width: 100,
                        dataIndex: 'num',
                        editable: mode === "edit" ? true : false,
                        // editable: mode != "look" ? true : false,
                    }, {
                        title: '已到货数量',
                        width: 100,
                        dataIndex: 'arrivedTotal',
                        // editable: mode == "edit" ? true : false,
                    }, {
                        title: '未到货数量',
                        width: 100,
                        dataIndex: 'unarrivedNum',
                        // editable: mode == "edit" ? true : false,
                    }, {
                        title: '商品大类',
                        width: 120,
                        dataIndex: 'ptypeName',
                        render: (text: any, res: any) => text ?? res.typeName
                    }, {
                        title: '商品小类',
                        width: 120,
                        dataIndex: 'typeName',
                    }, {
                        title: '规格型号',
                        width: 120,
                        dataIndex: 'model',
                        render: (text: any) => <YhTootip text={text} />,

                    }, {
                        title: '适用车型',
                        width: 120,
                        dataIndex: 'vehicleModel',
                        render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
                    }, {
                        title: '品牌',
                        width: 120,
                        dataIndex: 'brandName',
                        render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
                    }, {
                        title: '上装品牌',
                        width: 120,
                        dataIndex: 'upperClothBrand',
                        render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
                    }, {
                        title: '底盘品牌',
                        width: 120,
                        dataIndex: 'chassisBrand',
                        render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
                    }, {
                        title: '单位',
                        width: 60,
                        dataIndex: 'unitName',
                    }, {
                        title: '备注',
                        width: 120,
                        dataIndex: 'note',
                        editable: mode != "look" ? true : false,
                    }, {
                        title: '操作',
                        width: 60,
                        fixed: "right",
                        align: "center",
                        render: (text: any, record: any) => {
                            if (mode === 'add') {
                                return (
                                    <YhBut
                                        key="delete"
                                        type="delete"
                                        txt="删除"
                                        click={() => removeMaterial(record)}
                                    />
                                );
                            }

                            if (mode === 'edit') {
                                return (
                                    <YhAuth resCode={ResourceAuthEnum.P_PL_ED_CANCEL_M}>
                                        <YhBut
                                            key="invalid"
                                            type="warning"
                                            txt="作废"
                                            click={() => removeMaterial(record)}
                                        />
                                    </YhAuth>
                                );
                            }

                            // 默认返回空，避免无返回值的情况
                            return null;
                        }
                    }]
            } else {
                return [
                    {
                        title: '已到货数量',
                        width: 100,
                        dataIndex: 'arrivedTotal',
                        // editable: mode == "edit" ? true : false,
                    }, {
                        title: '未到货数量',
                        width: 100,
                        dataIndex: 'unarrivedNum',
                        // editable: mode == "edit" ? true : false,
                    }, {
                        title: '商品大类',
                        width: 120,
                        dataIndex: 'ptypeName',
                        render: (text: any, res: any) => text ?? res.typeName
                    }, {
                        title: '商品小类',
                        width: 120,
                        dataIndex: 'typeName',
                    }, {
                        title: '规格型号',
                        width: 120,
                        dataIndex: 'model',
                        render: (text: any) => <YhTootip text={text} />,

                    }, {
                        title: '适用车型',
                        width: 120,
                        dataIndex: 'vehicleModel',
                        render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
                    }, {
                        title: '品牌',
                        width: 120,
                        dataIndex: 'brandName',
                        render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
                    }, {
                        title: '上装品牌',
                        width: 120,
                        dataIndex: 'upperClothBrand',
                        render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
                    }, {
                        title: '底盘品牌',
                        width: 120,
                        dataIndex: 'chassisBrand',
                        render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
                    }, {
                        title: '单位',
                        width: 60,
                        dataIndex: 'unitName',
                    }, {
                        title: '备注',
                        width: 130,
                        dataIndex: 'note',
                        render: (text: any, record: any) => <YhTootip text={text} style={{ maxWidth: "130px" }} />,
                    }
                ]
            }
        })(),
    ];
    const removeMaterial = (record: IDetailList) => {
        detailDetailList(mode, record)
    }

    const typeList = {
        "add": detailAddList,
        "edit": detailDataSource,
        "look": detailLookList,
    }
    const newSelectColumns = () =>
        defaultColumns.map((col: any, index) => {
            let disaBled = col.dataIndex === "num"
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: record.deleteFlag == 1 ? false : col.dataIndex === "shelfCode" ? !record.isPurShelf : (disaBled ? record.planNum !== record.arrivedTotal : col?.editable),
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "purchasePlan", "roleCodes": roles };
        return getRoleColumns("purchasePlan", "明细", newSelectColumns(), params);
    }, [roles, typeList[mode], defaultColumns]);
    const handleSave = async (row: IDetailList, dataIndex: string) => {
        //货位的行编辑放到触焦里面操作， 防止覆盖赋值
        if (dataIndex !== "shelfCode") {
            let { num, planNum, price, warehouseCode, shelfCode, arrivedNum, arrivedTotal, unarrivedNum } = row
            num = +formatNum(num)
            planNum = +formatNum(planNum)
            price = +formatNum(price)
            arrivedTotal = +formatNum(arrivedTotal)
            unarrivedNum = +formatNum(unarrivedNum)
            num = +formatIntPoint(num, bigNumber.minus(planNum, arrivedTotal), "到货数量>未到货数量")
            let newRow = {
                ...row,
                num,
                warehouseName: getFindItem(warehouseCode as string, warehouseData[mode])?.name,
                // shelfId: getFindItem(shelfCode as string, shelfAllList)?.id ?? row.shelfId,
                amount: +formatNum(planNum * price),
                arrivedNum,
            }
            let newData = mode === "edit" ? detailDataSource : detailAddList;
            const index = newData.findIndex((item) => row.detailsId === item.detailsId);
            const item = newData[index];

            //判断仓库变化时，  重置货位
            if (newRow.warehouseCode !== newData[index].warehouseCode) {
                setLoading(true)
                try {
                    //货位列表
                    let newRecords = []
                    let params = {
                        pageSize: 99999,
                        pageNum: 1,
                        warehouseCode: newRow.warehouseCode,
                    }
                    const { retData: shelfAll } = await warehouseService.shelfAllPage(params)
                    newRecords = shelfAll.map((item: IVRMshelfDetail) => { return { ...item, name: item.code } })
                    setShelfAllList(newRecords);
                    //查询配件有没有在改仓库下采购过， 
                    let { retData } = await purchasePoService.getMaterialShelf({
                        shopId,
                        materialCode: newRow.materialCode,
                        warehouseCode: newRow.warehouseCode
                    })
                    // 采购过的货位带出来不可以编辑， 其它的可以编辑(有临时货位默认带出临时货位)
                    if (retData.shelfCode) {
                        newRow.shelfCode = retData.shelfCode ?? '';
                        newRow.shelfId = retData.shelfId ?? '';
                        newRow.isPurShelf = retData.shelfCode ?? '';  //做是否可编辑
                        message.warning(`自动匹配到配件【${newRow.materialCode}】在该仓库下采购的货位，货位不可做修改操作！！`)
                    } else {
                        let isTemp = newRecords?.find(item => (item.code ?? "").indexOf("临时货位") > -1);
                        newRow.shelfCode = isTemp?.code ?? '';
                        newRow.shelfId = isTemp?.id ?? '';
                        newRow.isPurShelf = "";
                    }
                    setLoading(false)
                } catch (e) {
                    setLoading(false)
                }
            }
            newData.splice(index, 1, { ...item, ...newRow });
            mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
            setTopButsControl(true)
        }
    }

    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }
    return (
        <YhBox title="配件信息" rightChildren={action} style={{ marginBottom: "75px", height: (roles.includes('hd-supplier') && supMore) ? 'calc(100vh - 310px)' : (roles.includes('hd-supplier') && !supMore) ? 'calc(100vh - 480px)' : (!roles.includes('hd-supplier') && more) ? 'calc(100vh - 480px)' : 'calc(100vh - 570px)' }}>
            <Table
                bordered
                loading={{ tip: "数据查询中...", spinning: loading }}
                // rowClassName='editable-row yh-edit-table-tr'
                rowClassName={(record) => record.deleteFlag == 1 ? "editable-row yh-edit-table-tr strikethrough" : 'editable-row yh-edit-table-tr'}
                rowKey={record => record.detailsId as string}
                rowSelection={
                    mode === DetailType.look ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={typeList[mode]}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                scroll={{ x: 'max-content', y: (roles.includes('hd-supplier') && supMore) ? 'calc(100vh - 410px)' : (roles.includes('hd-supplier') && !supMore) ? 'calc(100vh - 580px)' : (!roles.includes('hd-supplier') && more) ? 'calc(100vh - 580px)' : 'calc(100vh - 670px)' }}
            />
            <LookPictureModal
                visible={imageModalVisible}
                materialCode={currentMaterialCode}
                onClose={handleCloseImageModal}
            />
        </YhBox>
    )
}